import Modal from '@Components/Shared/Modals/Modal';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import PhoneField from '@Components/MuiWrappers/PhoneField';
import { useState } from 'react';

import Typography from '@mui/material/Typography';

const EmailAlertsTextAlertModal = (props) => {
    const [validationError, setValidationError] = useState(null);

    const onSubmit = (subscribe, skipPhoneConfirmationCheck) => {
        if (subscribe && props.intlTelInput.current?.isValidNumber() == false) {
            setValidationError(translator.translate('sandhills.invalidphone').toString());
        } else {
            setValidationError('');
            props.onSubmit(subscribe, skipPhoneConfirmationCheck);
        }
    }

    const getHelperText = () => {
        if (validationError) {
            return validationError;
        } else if (props.displayError) {
            return translator.translate('sandhills.anerroroccuredpleasetryagain');
        }
        return undefined;
    };

    return (
        <Modal containerClassName='alert-modal text-alerts-modal' onEscapeKeyClose={props.onClose}>
            <Modal.Header onClose={props.onClose}>
                <div className="top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        <TranslationText tKey='sandhills.textmessagealerts' />
                    </Modal.Title></div>
            </Modal.Header>
            {props.phoneSubscribedSuccess || props.phoneRemovedSuccess ?
                <Modal.Body>
                    {props.phoneSubscribedSuccess ? 
                        <div className='success'>{translator.translate('sandhills.tradesites.mvc.phonenumbersuccessfullyadded')}</div>      
                        :
                        <div className='success'>Phone number successfully removed</div>
                    } 
                </Modal.Body>
                : props.showDeletePhoneConfirmation ? 
                    <Modal.Body>
                        <Typography style={{ fontSize: '12px', textTransform: 'none' }} color='error.main' dangerouslySetInnerHTML={{ __html: props.smsPhoneRemovalConfirmationText }} />
                        <div className='bottom-buttons'>
                            <input type='button' className='button ts-button' value={translator.translate('sandhills.ok')} onClick={() => onSubmit(false, true)} />
                            <input type='button' className='button ts-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
                        </div>
                    </Modal.Body>
                    :
                    <Modal.Body>
                        <strong className='sub-header'>{translator.translate('sandhills.tradepubwebsite.mvc.tosetuptextmessagealerts')}</strong>

                        <div className='smaller-text'><TranslationText tKey='sandhills.tradesites.mvc.smspleaseenteryourphone' /></div>

                        <div className='phone-input'>
                            <PhoneField
                                id='Phone'
                                name='Phone'
                                size='small'
                                value={props.modalInfo?.PhoneNumber}
                                onChange={props.onChange}
                                label={translator.translate('sandhills.phonenumber')}
                                placeholder={'(xxx) xxx-xxxx'}
                                fullWidth
                                intlTelInput={input => props.intlTelInput.current = input}
                                error={getHelperText() ? true : false}
                                disabled={props.showPhoneConfirmation}
                                helperText={getHelperText()}
                            />
                        </div>
                        {!props.showPhoneConfirmation ?
                            <>
                                <div className='opt-out' dangerouslySetInnerHTML={{ __html: props.textAlertOptOutText }} />
                                <div className='bottom-buttons'>
                                    <input type='button' className='button ts-button' value={translator.translate('sandhills.tradepubwebsite.mvc.submit')} onClick={()=> onSubmit(true, false)} />
                                    <input type='button' className='button ts-button cancel-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
                                </div>
                            </>
                            :
                            <>
                                <Typography style={{ fontSize: '12px', textTransform: 'none' }} color='error.main' dangerouslySetInnerHTML={{ __html: props.smsPhoneUpdateConfirmationText }} />
                                <Typography color='error.main' sx={{ fontSize: '12px' }}>
                                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.oldinfo' /> : {props.currentSMSPhone}
                                </Typography>
                                <Typography color='error.main' sx={{ fontSize: '12px' }}>
                                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.newinfo' /> : {props.intlTelInput.current?.getNumber()}
                                </Typography>
                                <div className='bottom-buttons'>
                                    <input type='button' className='button ts-button' value={translator.translate('sandhills.ok')} onClick={()=> onSubmit(true, true)} />
                                    <input type='button' className='button ts-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
                                </div>
                            </>}
                    </Modal.Body>
            }
            {(props.disableSubmit) && <LoadingRing backdrop />}
        </Modal>
    );
}

export default EmailAlertsTextAlertModal;